/* eslint-disable react-hooks/exhaustive-deps */
import {
    Box,
    Button,
    Typography,
    InputAdornment,
    IconButton,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import StyledResetPassword from "./StyledResetPassword";
  import { INPUT_LABELS } from "../../constants/lang";
  import { Controller, useForm } from "react-hook-form";
  import TextFeild from "../../components/CommonComponents/TextFeild";
  import { yupResolver } from "@hookform/resolvers/yup";
  import { resetPasswordSchema } from "../../schema/forgetPasswordSchema";
  import { ROUTE_PATH } from "../../constants/route";
  import { Link, useNavigate, useParams } from "react-router-dom";
  import VisibilityIcon from "@mui/icons-material/Visibility";
  import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useDispatch } from "react-redux";
import { ToastNotifyError, ToastNotifySuccess } from "../../components/CommonComponents/Toast/ToastNotify";
import { fetchResetLinkCheck, fetchResetPassword } from "../../store/reducers/authentication/apiThunk";
import rollbar from "../../rollbarConfig";
import ShimmerLoader from "../../components/CommonComponents/Loader/ShimmerLoader";
  
  const { LOGIN } = ROUTE_PATH;
  
  const ResetPassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(true);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const { uid, token } = useParams();
  
    const {
      control,
      handleSubmit,
      formState: { errors },
    } = useForm({
      resolver: yupResolver(resetPasswordSchema),
    });
  
    const handleTogglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };
  
    const handleToggleConfirmPasswordVisibility = () => {
      setShowConfirmPassword(!showConfirmPassword);
    };

    const checkResetLink = async () => {
        setLoading(true);
        const dataToSend = {
          uid: uid,
          token: token,
        };
        try {
          const response = await dispatch(fetchResetLinkCheck(dataToSend));
          const { status, message, data } = response?.payload;
    
          if (status) {
            if (data?.link_valid) {
              setLoading(false);
              return true;
            } else {
              navigate(ROUTE_PATH.FORGET_PASSWORD_LINK_EXPIRED, {
                state: { data: data?.email },
              });
              setTimeout(() => {
                  setLoading(false);
              }, 200)
            }
          } else {
            ToastNotifyError(message);
            setLoading(false);
          }
        } catch (error) {
          console.error("Error checking reset link:", error);
        }
      };

      useEffect(() => {
        checkResetLink();
      }, []);
  
    const onSubmit = async (data) => {
        setLoading(true);
        const dataToSend = {
          uid: uid,
          token: token,
          new_password: data.newPassword,
          confirm_password: data.confirmPassword,
        };
        try {
          const res = await dispatch(fetchResetPassword(dataToSend));
          const { status, message } = res?.payload || {};
          if (status === true) {
            ToastNotifySuccess(message);
            navigate(LOGIN);
            setLoading(false);
          } else if (status === 400) {
            ToastNotifyError(res?.payload?.response?.data?.message || 'An error occurred. Please try again.');
            setLoading(false);
          } else {
            ToastNotifyError('An error occurred. Please try again.');
            setLoading(false);
          }
        } catch (error) {
          rollbar.error("Error message", error);
          setLoading(false);
          ToastNotifyError("An error occurred. Please try again.");
        }
    };
  
    return (
      <StyledResetPassword>
        {isLoading && (
          <Box className='loader-wrap'>
            <ShimmerLoader />
          </Box>
        )}
        <Box
          component='form'
          onSubmit={handleSubmit(onSubmit)}
          className='resetPass-wrap'
        >
          <Typography className='resetPass-header'>Reset password</Typography>
          <Typography className='resetPass-sub-header'>
            Your new password must be different to previous password
          </Typography>
          <Box className='resetPass-textfeilds'>
            <Box className='signup-email'>
              <Controller
                name='newPassword'
                control={control}
                className='password-feild'
                defaultValue=''
                render={({ field }) => (
                  <TextFeild
                    label={INPUT_LABELS.newPassword}
                    placeholder='Enter your new password'
                    variant='outlined'
                    fullWidth
                    required
                    margin='normal'
                    type='password'
                    show={showPassword}
                    isShow={setShowPassword}
                    error={!!errors.newPassword}
                    helperText={errors.newPassword?.message}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton
                            aria-label='toggle password visibility'
                            onClick={handleTogglePasswordVisibility}
                            edge='end'
                          >
                            {showPassword ? (
                              <VisibilityOffIcon />
                            ) : (
                              <VisibilityIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    {...field}
                  />
                )}
              />
            </Box>
            <Box className='signup-email'>
              <Controller
                name='confirmPassword'
                control={control}
                className='confirmPassword-feild'
                defaultValue=''
                render={({ field }) => (
                  <TextFeild
                    label={INPUT_LABELS.confirmPassword}
                    placeholder='Enter same password again'
                    variant='outlined'
                    fullWidth
                    required
                    margin='normal'
                    type='password'
                    show={showConfirmPassword}
                    isShow={setShowConfirmPassword}
                    error={!!errors.confirmPassword}
                    helperText={errors.confirmPassword?.message}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton
                            aria-label='toggle confirm password visibility'
                            onClick={handleToggleConfirmPasswordVisibility}
                            edge='end'
                          >
                            {showConfirmPassword ? (
                              <VisibilityOffIcon />
                            ) : (
                              <VisibilityIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    {...field}
                  />
                )}
              />
            </Box>
          </Box>
          <Button
            isLoading={isLoading}
            disabled={isLoading}
            type='submit'
            variant='contained'
            color='primary'
            sx={{
              width: "100%",
              padding: "10px",
              marginTop: "24px",
              fontSize: "16px",
              textTransform: "none",
            }}
          >
            Submit
          </Button>
          <Box className='backLogin'>
            <Link to={LOGIN} aria-label='login button'>
              Back to login
            </Link>
          </Box>
        </Box>
      </StyledResetPassword>
    );
  };
  
  export default ResetPassword;
  